module.exports = __webpack_public_path__ + "./Katherine_color_a38d4608415610374c7dfde9669842ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Katherine_color.jpg
// module id = 594
// module chunks = 0